import React from "react";
import { Box, Button, Modal } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "./EventConfirmModal.css";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 480,
  maxWidth: "calc(100vw - 32px)",
  bgcolor: "background.paper",
  borderRadius: "12px",
  boxShadow: 24,
  p: "28px 34px 34px",
  outline: "none",
  textAlign: "center",
};

export const EmailTemplateResetModal = ({
  open,
  onClose,
  onConfirm,
  confirming = false,
  templateName = "this template",
}) => {
  return (
    <Modal
      open={open}
      onClose={confirming ? undefined : onClose}
      aria-labelledby="email-template-reset-title"
    >
      <Box sx={modalStyle} className="event-confirm-modal">
        <button
          type="button"
          className="event-confirm-modal__close"
          onClick={onClose}
          disabled={confirming}
          aria-label="Close"
        >
          <CloseIcon sx={{ fontSize: 18 }} />
        </button>
        <h2 id="email-template-reset-title">Reset to default?</h2>
        <p className="event-confirm-modal__body">
          This replaces the {templateName} design with the Quest default
          invitation template and re-provisions it to email sending. Your
          customizations will be lost.
        </p>
        <div className="event-confirm-modal__actions">
          <Button
            type="button"
            variant="outlined"
            className="event-confirm-modal__btn-secondary"
            onClick={onClose}
            disabled={confirming}
          >
            Keep template
          </Button>
          <Button
            type="button"
            variant="contained"
            className="event-confirm-modal__btn-primary"
            disableElevation
            onClick={onConfirm}
            disabled={confirming}
          >
            {confirming ? "Resetting…" : "Reset to Default"}
          </Button>
        </div>
      </Box>
    </Modal>
  );
};
